<template>
  <v-container class="main-container">
    <v-row>
      <v-col cols="12">
        <v-card
          tile
          flat
          class="pa-5"
          color="transparent"
        >
          <AllSendEmailTabs></AllSendEmailTabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import AllSendEmailTabs from "@/components/MarketingTool/AllSendEmailTabs.vue";

export default {
  components: {
    AllSendEmailTabs,
  },
};
</script>
